import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { customerBlockedQuery } from '../../../../../../store/customerDetail/selector';
import { ICustomerBlockedNormalized } from '../../../../../../store/customerDetail/types';

import { BlockedDesktop } from './Desktop';
import { BlockedMobile } from './Mobile';
import { BlockedTablet } from './Tablet';

export namespace BlockedTypes {
  export interface BaseProps {}
  export interface Props extends BaseProps {
    isLoading: boolean;
    blockedAssets: ICustomerBlockedNormalized['blockedAssetsNormalized'];
    error: any;
    onRefresh: () => void;
  }
}

export const Blocked: React.FC<BlockedTypes.BaseProps> = (props) => {
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { refresher, data, error, loading } = useRecoilQuery(
    customerBlockedQuery({ accountNumber: route.params.accountNumber })
  );

  const componentProps: BlockedTypes.Props = {
    ...props,
    isLoading: loading,
    blockedAssets: data?.data.blockedAssetsNormalized || [],
    error,
    onRefresh: refresher,
  };

  const content = useBreakpointValue({
    base: <BlockedMobile {...componentProps} />,
    sm: <BlockedTablet {...componentProps} />,
    lg: <BlockedDesktop {...componentProps} />,
  });

  return content;
};
